import { createContext, useContext } from 'react';
import { AuthUser } from './AuthUserModels';

export type UserContextProps = {
  readonly user: AuthUser | undefined;
  refresh: () => void;
  updateUser: (user: DeepPartial<AuthUser>) => void;
  updateUserDateTimeFormatConfig: (dateTimeFormatConfig: AuthUser['preferences']['dateTimeFormatConfig']) => void;
};

export const AuthUserContext = createContext<UserContextProps>({
  user: undefined,
  updateUserDateTimeFormatConfig: () => {},
  refresh: () => {},
  updateUser: () => {}
});

export const AuthUserProvider = AuthUserContext.Provider;

export function useAuthUserContext() {
  return useContext<UserContextProps>(AuthUserContext);
}
